import { types } from 'mobx-state-tree';

const Destination = types.model('Destination', {
  dateStatusChecked: types.string,
  id: types.string,
  marketplaceId: types.string,
  marketplaceTypeId: types.string,
  allowGlobalShipping: types.boolean,
  name: types.string,
  status: types.maybe(types.string),
});

const Source = types.model('Source', {
  currency: types.string,
  id: types.string,
  marketplaceId: types.string,
  marketplaceTypeId: types.string,
  name: types.string,
  isBuyItForMeAccount: types.boolean,
  isActive: types.boolean,
  otpSecretKey: types.maybe(types.string),
  password: types.maybe(types.string),
  lastDigitsCard: types.maybe(types.string),
  dateCreated: types.maybe(types.string),
});

const Paypal = types.model('Paypal', {
  dateCreated: types.maybe(types.string),
  id: types.string,
  name: types.string,
  marketplaceTypeId: types.string,
  isBillable: types.maybe(types.boolean),
});

const Payoneer = types.model('Payoneer', {
  dateCreated: types.maybe(types.string),
  id: types.string,
  name: types.string,
  marketplaceTypeId: types.string,
  isBillable: types.maybe(types.boolean),
});
const Stripe = types.model('Stripe', {
  dateCreated: types.maybe(types.string),
  id: types.string,
  name: types.string,
  last4Digits: types.string,
  marketplaceTypeId: types.string,
  isBillable: types.maybe(types.boolean),
});

const Currency = types.model('Currency', {
  currency: types.string,
  marketplace: types.string,
  destination: types.array(Destination),
  source: types.array(Source),
  paypal: types.array(Paypal),
  payoneer: types.array(Payoneer),
  stripe: types.array(Stripe),
});

export default Currency;
